import { useCallback, useState } from 'react';
import { Box, Items, ListItem, Loading, LoadingDiv, LoadingWrap, LockIcon, ProjectList, Text, Title } from './styles';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { isEmpty } from '../../../helpers/common';
import { GithubRepositoryList } from '../../../interfaces/SettingsInterface';
import { EMPTY_STATE_SIZE, ICON_SIZE } from '../../../global/constants';
import { observer } from 'mobx-react-lite';
import EmptyStateV2 from '../../emptyState';
import ModalHeader from '../modalHeader';

interface Props {
  githubRepositoryList: GithubRepositoryList[];
  onClose?: () => void;
  handleSelect: (id: GithubRepositoryList) => void;
  loading: boolean;
}
function SearchRepositoryModel(props: Props) {
  const { githubRepositoryList, onClose, handleSelect, loading } = props;
  //State variables
  const [searchInput, setSearchInput] = useState('');
  const [filteredGithubRepoList, setFilteredGithubRepoList] = useState<GithubRepositoryList[]>(githubRepositoryList);

  //Handle repository search
  const handleSearch = useCallback(
    (value: string) => {
      setSearchInput(value);
      if (!isEmpty(value)) {
        const searchText = searchInput.trim().toLowerCase();
        const filteredRepositories: GithubRepositoryList[] = githubRepositoryList?.filter((repo) => {
          const repoName = repo?.fullName?.trim().toLowerCase() || '';
          return repoName.includes(searchText);
        });
        setFilteredGithubRepoList(filteredRepositories);
      } else {
        setFilteredGithubRepoList(githubRepositoryList);
      }
    },
    [githubRepositoryList, searchInput]
  );
  return (
    <>
      <ModalHeader placeHolder='Search repositories' onSearchChange={(e) => handleSearch(e)} onClose={onClose} />
      <ProjectList>
        {!loading && !isEmpty(githubRepositoryList) && !isEmpty(filteredGithubRepoList) && (
          <Title>Your repositories</Title>
        )}
        {!loading && isEmpty(githubRepositoryList) && (
          <Box>
            <EmptyStateV2 size={EMPTY_STATE_SIZE.SMALL} title='No repositories' imageUrl='empty_repo' />
          </Box>
        )}
        {loading && (
          <Box>
            <LoadingDiv>
              <LoadingWrap>
                <Loading />
              </LoadingWrap>
              <Text>Loading...</Text>
            </LoadingDiv>
          </Box>
        )}
        {!loading && !isEmpty(githubRepositoryList) && isEmpty(filteredGithubRepoList) && (
          <Box>
            <EmptyStateV2
              size={EMPTY_STATE_SIZE.SMALL}
              title='No search results found.'
              description='Try changing your search term.'
              imageUrl='no_repo_found'
            />
          </Box>
        )}
        {!loading && !isEmpty(githubRepositoryList) && !isEmpty(filteredGithubRepoList) && (
          <Items>
            {!loading &&
              !isEmpty(githubRepositoryList) &&
              !isEmpty(filteredGithubRepoList) &&
              filteredGithubRepoList?.map((repo) => (
                <ListItem role='button' key={repo?.id} onClick={() => handleSelect(repo)}>
                  {repo?.private ? (
                    <LockIcon>
                      <SVGIcon
                        name='lock-icon'
                        width={ICON_SIZE.MD}
                        height={ICON_SIZE.MD}
                        viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                        fill='var(--text-primary)'
                      />
                    </LockIcon>
                  ) : (
                    <LockIcon>
                      <SVGIcon
                        name='repo-public-icon'
                        width={ICON_SIZE.MD}
                        height={ICON_SIZE.MD}
                        viewBox={`0 0 ${ICON_SIZE.MD} ${ICON_SIZE.MD}`}
                      />
                    </LockIcon>
                  )}
                  <p>{repo?.fullName}</p>
                </ListItem>
              ))}
          </Items>
        )}
      </ProjectList>
    </>
  );
}

export default observer(SearchRepositoryModel);
